<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, minValue } from "vuelidate/lib/validators";
// import DatePicker from "vue2-datepicker";
import axios from "axios";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import moment from "moment";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import MaskedInput from "vue-text-mask";
import Vue from "vue";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

Vue.use(Toasted);
/**
 * new orden component
 */
export default {
  page: {
    title: "Nueva Compra",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Vuetable,
    VuetablePagination,
    // DatePicker,
    Loader,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    "masked-input": MaskedInput,
  },
  data() {
    return {
      arrayProveedores:[],
      arrayProveedor:[],
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      apiBase:
        process.env.VUE_APP_URL +  "concentrado/get",
      saldo: 0,
      // Variables para metodos de pago
      cantidad_efectivo: "",
      transferencia: {
        cantidad_transferencia: "",
        transaccion_transferencia: "",
      },
      cheque: {
        cantidad_cheque: "",
        transaccion_cheque: "",
      },
      checkMoney: {
        efectivo: false,
        cheque: false,
        transferencia: false,
      },
      checkSelect: {
        efectivo: false,
        cheque: false,
        transferencia: false,
      },
      montoFinal: {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      },
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      // variables para detalle
      cabezera: [
        { key: "codigo", label: "Codigo producto", thClass: "cell1" },
        { key: "nombre", label: "Producto", thClass: "cell1" },
        { key: "cantidad", label: "Cantidad", thClass: "cell1" },
        { key: "precio_compra", label: "Precio Compra", thClass: "cell1" },
        { key: "precio_venta", label: "Precio Venta", thClass: "cell1" },
        { key: "subtotal", label: "Subtotal", thClass: "cell1" },
      ],
      apiUrl: process.env.VUE_APP_URL,
      fieldsBusqueda: [{
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
        {
          name: "nombre_producto",
          title: "Producto",
          sortField: "nombre_producto",
          width: "20%",
        },
        {
          name: "codigo_stock",
          title: "Código",
          sortField: "codigo_stock",
          width: "20%",
        },
        {
          name: "precio_compra",
          title: "Precio Compra",
          sortField: "precio_compra",
          width: "20%",
        },
        // {
        //   name: "producto.marca.nombre_marca",
        //   title: "Marca",
        //   sortField: "producto.marca.nombre_marca",
        //   width: "20%",
        // },
        {
          name: "existencia",
          title: "Existencia",
          sortField: "existencia",
          width: "20%",
        },],
      fields: [
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
        {
          name: "nombre_producto",
          title: "Producto",
          sortField: "nombre_producto",
          width: "20%",
        },
        {
          name: "codigo_stock",
          title: "Codigo",
          sortField: "codigo_stock",
          width: "20%",
        },
        // {
        //   name: "marca.nombre_marca",
        //   title: "Marca",
        //   sortField: "marca.nombre_marca",
        //   width: "20%",
        // },
        {
          name: "existencia_stock",
          title: "Existencia",
          sortField: "existencia_stock",
          width: "20%",
        },
      ],
      formPro: {
        fecha_limite: new Date(),
        proveedorid: 1,
        metodo_pago: "0",
        factura: "",
        fecha_compra: new Date(),
        fecha_entrega: new Date(),
        tiendaid: "",
        tienda: "",
        orden: "",
        proveedor: "",
        total: "",
        state: true,
        observaciones : "",
        id: 0,
      },
      data: [
        {
          nombre: "",
          cantidad: "",
          precio_compra: "",
          precio_venta: "",
          subtotal: "",
          ubicacion: "",
          sub_presentacion: "",
          button: true,
        },
      ],
      title: "Nueva Compra",
      items: [
        {
          text: "Compras",
          href: "/",
        },
        {
          text: "Compra",
          active: true,
        },
      ],
      searchType: [
        { nombre: "Nombre", value: "producto" },
        // { nombre: "Codigo", value: "codigo" },
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      loadingtable: false,
      sortBy: "nombre_producto",
      sortDesc: false,
      searchLabel: { nombre: "Nombre", value: "producto" },
      filterLabel: { nombre: "Nombre", value: "producto" },
      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
      arrayDetalle: [],
    };
  },
  validations: {
    formPro: {
      proveedor: { required },
      factura: { required },
      fecha_entrega: { required },
      fecha_compra: { required },
      fecha_limite: { required },
      tienda: { required },
      orden: { required },
      total: { required },
    },
    arrayDetalle: {
      required,
      $each: {
        cantidad: {
          required,
        },
        ubicacion: {
          required,
        },
      },
    },
    data: { required },

    cantidad_efectivo: {
      required,
      minValue,
    },
    transferencia: {
      cantidad_transferencia: {
        required,
      },
      transaccion_transferencia: {
        required,
      },
    },
    cheque: {
      cantidad_cheque: {
        required,
      },
      transaccion_cheque: {
        required,
      },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.getproveedor();
    // this.gettienda();
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal: function () {
      let resultado = 0.0;
      if (this.arrayDetalle.length) {
        for (let i = 0; i < this.arrayDetalle.length; i++) {
          if (
            this.arrayDetalle[i].subtotal == "" ||
            this.arrayDetalle[i].subtotal == null
          ) {
            resultado = resultado + 0;
          } else {
            resultado =
              parseFloat(resultado) + parseFloat(this.arrayDetalle[i].subtotal);
          }
        }
      }

      return resultado.toFixed(2);
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // PROVEEDORES
   
    async selectProveedor(valor) {
      this.arrayProveedor = [];
      for (var i = 0; i < this.arrayProveedores.length; i++) {
        const estado = this.arrayProveedores[i].nombre
          .toLowerCase()
          .includes(valor.toLowerCase());
        if (estado === true) {
          this.arrayProveedor.push(this.arrayProveedores[i]);
          // console.log(this.arrayProveedor)
        } else {
          // console.log("nada")
        }
      }
    },
    async getproveedor() {
      this.arrayProveedores = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL + "proveedores/busqueda",
          {
            headers: { "x-token": this.userT.token },
          }
        );
        // console.log(response.data)
        this.arrayProveedores = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    // Metodos de pago
    checkboxChange(action) {
      this.$v.$reset();
      if (action == "efectivo" && !this.checkMoney.efectivo) {
        this.checkSelect.transferencia = false;
        this.checkSelect.cheque = false;
        this.cantidad_efectivo = "";
        this.montoFinal = {
          cantidad: "",
          metodo: "",
          transaccion: "",
        };
      } else if (action == "efectivo" && this.checkMoney.efectivo) {
        this.montoFinal.metodo = "Efectivo";
        this.checkSelect.transferencia = true;
        this.checkSelect.cheque = true;
      }

      if (action == "transferencia" && !this.checkMoney.transferencia) {
        this.checkSelect.efectivo = false;
        this.checkSelect.cheque = false;
        this.transferencia = {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
        };
        this.montoFinal = {
          cantidad: "",
          metodo: "",
          transaccion: "",
        };
      } else if (action == "transferencia" && this.checkMoney.transferencia) {
        this.montoFinal.metodo = "Transferencia";
        this.checkSelect.efectivo = true;
        this.checkSelect.cheque = true;
      }

      if (action == "cheque" && !this.checkMoney.cheque) {
        this.checkSelect.efectivo = false;
        this.checkSelect.transferencia = false;
        this.cheque = {
          cantidad_cheque: "",
          transaccion_cheque: "",
        };
        this.montoFinal = {
          cantidad: "",
          metodo: "",
          transaccion: "",
        };
      } else if (action == "cheque" && this.checkMoney.cheque) {
        this.montoFinal.metodo = "Cheque";
        this.checkSelect.efectivo = true;
        this.checkSelect.transferencia = true;
      }
    },
    sumarCantidades(accion, cantidad) {
      if (accion == 1) {
        this.montoFinal.cantidad = parseFloat(
          this.converMaskToNumberxd(cantidad)
        );
      } else {
        this.montoFinal.transaccion = cantidad;
      }
    },

    // async gettienda() {
    //   let me = this;
    //   me.formPro.tiendaid = "";
    //   me.formPro.tienda = "";
    //   const id = this.userT.tienda
    //   axios
    //     .get(process.env.VUE_APP_URL + "tiendas/selectById?id="+id, {
    //       headers: { "x-token": this.userT.token },
    //     })
    //     .then(function (response) {
    //       // console.log(response);
    //       me.formPro.tienda = response.data.data.nombre_tienda;
    //       me.formPro.tiendaid = response.data.data.id;
    //       // console.log(me.formPro.tienda, me.formPro.tiendaid);
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // },
    tomandototal() {
      let temp = 0;
      temp = parseFloat(this.calcularTotal);
      this.formPro.total = temp;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      this.$v.$touch();
      // console.log(this.formPro.proveedor);
      if (
        this.formPro.proveedor == "" || this.formPro.proveedor == null
      ) {
        // console.log("retroll");
        Vue.toasted.error("Revise la cabecera de la compra ", this.options);
        return;
      } 
      else if(this.arrayDetalle.length <=0){
        Vue.toasted.error("Agregue Detalles a la compra ", this.options);
        return;
      }
      
      else {
        if (opc == "save" && this.formPro.metodo_pago == "1") {
          if (
            this.montoFinal.cantidad >= 0 &&
            this.montoFinal.cantidad < this.formPro.total &&
            this.montoFinal.metodo === "Efectivo"
          ) {
            this.showModalL = true;
            this.saldo = this.formPro.total - this.montoFinal.cantidad;
            this.save();

            // console.log("Entrando efectivo")
          } else if (
            this.montoFinal.cantidad >= 0 &&
            this.montoFinal.cantidad < this.formPro.total &&
            this.montoFinal.metodo != "Efectivo" &&
            this.montoFinal.transaccion != ""
          ) {
            this.showModalL = true;
            this.saldo = this.formPro.total - this.montoFinal.cantidad;
            // console.log('esto saber k')
            this.save();
          } else {
            Vue.toasted.error(
              "Revise los metodos de compra si la información es correcta.",
              this.options
            );
          }
        }
        if (opc == "save" && this.formPro.metodo_pago == "0") {
          this.saldo = 0;
          this.showModalL = true;
          // console.log('llega al save')
          this.save();
        }
      }
    },
    //Guardar registro
    async save() {
      // console.log('esta llegando')
      this.showModalL = true;
      const {
        // tiendaid,
        observaciones,
        // fecha_entrega,
        // fecha_compra,
        // factura,
        // fecha_limite,
        // proveedorid,
        proveedor,
        total,
        metodo_pago,
      } = this.formPro;
      // console.log(proveedorid);
      const me = this;
      const datos = await this.arrayDetalle.map(function (item) {
        const fechac = me.converMaskToNumberxd(item.precio_compra);
        const fechav = me.converMaskToNumberxd(item.precio_venta);
        return {
          cantidad: item.cantidad,
          precio_compra_a: item.precio_compra_a,
          precio_venta_a: item.precio_venta_a,
          precio_compra: fechac,
          precio_venta: fechav,
          subtotal: item.subtotal,
          id: item.id,
        };
      });

      axios
        .post(
          process.env.VUE_APP_URL + "compras/store",
          {
            // fecha_entrega: me.customFormatter(fecha_entrega),
             fecha_compra: this.customFormatter(new Date()),
            // fecha_pago: me.customFormatter(fecha_limite),
            usuario: this.userT.id,
            // no_documento: factura,
            tienda: 1,
            proveedor: proveedor.id,
            tipo_compra_c : 1,
            total,
            saldo: this.saldo,
            detalle : datos,
            observaciones: observaciones,
            metodo: metodo_pago,
            // Metodos de pago
            metodo_pgo: this.montoFinal.metodo,
            codigo_paago: this.montoFinal.transaccion,
            abono: this.montoFinal.cantidad,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Registro Guardado", this.options);
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
          this.$router.push({
            name: "compras",
            shallow: true,
          });
        });
    },
    // Funciones para trabajar con detalles

    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // Funciones para formatos
    updateDisableDates({ item, index }) {
      const me = this;
      console.log(item);
      if (me.arrayDetalle[index].cantidad != "") {
        me.arrayDetalle[index].subtotal =
          parseFloat(me.arrayDetalle[index].cantidad) *
          parseFloat(
            me.converMaskToNumberxd(me.arrayDetalle[index].precio_compra)
          );
      }
      this.$refs.table.refresh();

      // item.no_extras = 0;
    },
    formatQuetzales(amount) {
      let num = parseFloat(amount),
        formatted;
      formatted = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return (amount = "Q " + formatted);
    },
    getLabel: function (val) {
      return val.departamento.nombre_departamento;
    },
    getLabe2: function (val) {
      return val.no_orden + "-" + val.user.empleado.persona.nombre_persona;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    agregarDetalle(data) {
      // console.log(data);
      const { precio_compra,precio_venta,codigo_stock,id,nombre_producto} = data

      const me = this;
      if(me.encuentra(id)){
            Vue.toasted.error("El producto seleccionado ya se encuentra en el detalle", this.options);
          }else{
            me.arrayDetalle.push({
              precio_compra: this.money(precio_compra >0 ? precio_compra : 0.0),
              precio_venta: this.money(precio_venta >0 ? precio_venta : 0.0),
              precio_compra_a: precio_compra >0 ? precio_compra : 0.0,
              precio_venta_a: precio_venta >0 ? precio_venta : 0.0,
              id: id,
              codigo_stock: codigo_stock,
              nombre_producto: nombre_producto,
              cantidad: 1,
              subtotal: precio_compra,
            });
          } 
    },
    verificarstock(stock) {
      const me = this;
      // console.log(stock)
      if (me.encuentra(stock["id"].toString())) {
        return true;
      }
    },
    // Esta función encuentra si en el detatalle ya esta la habitacion
    encuentra(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalle.length; i++) {
        if (this.arrayDetalle[i].id.toString() == id) {
          sw = true;
        }
      }
      return sw;
    },


    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
      // console.log(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            tienda :  this.userT.tienda,
          }
        : {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            tienda :  this.userT.tienda,
          };
    },
  },
};
</script>

<template>
  <Layout>
    <b-modal
      centered
      v-model="showModalL"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
      content-class="my-class"
      header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                :animation-duration="2000"
                :size="90"
                color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row">
                <div class="col-">
                  <div class="row">
                    <div class="col">
                      <h4>Datos Generales</h4>
                    </div>

                    <div class="col" align="center">
                      <div class="mt-4 mt-sm-0">
                        <p class="text-muted mb-2">Total</p>
                        <h3>
                          {{
                            formatQuetzales(
                              formPro.total > 0 ? formPro.total : 0.0
                            )
                          }}
                        </h3>
                      </div>
                    </div>
                    <div class="col" align="right">
                      <div>
                        <router-link
                          :to="{
                            name: 'compras',
                          }"
                        >
                          <b-button
                            variant="outline-primary"
                            type="button"
                            class="btn btn-rounded mb-2 me-2"
                          >
                            <i class="mdi mdi-arrow-collapse-left"></i> Regresar
                          </b-button>
                        </router-link>
                      </div>
                    </div>
                  </div>

                  <div class="text-center">
                    <div class="row">
                      <div class="col-sm-3">
                        <div>
                        <p class="text-muted mb-2">Proveedor</p>
                        <v-select
                          v-model.trim="$v.formPro.proveedor.$model"
                          :state="!$v.formPro.proveedor.$error"
                          :options="arrayProveedor"
                          @search="selectProveedor"
                          placeholder="Buscar Proveedor..."
                          label="nombre"
                        >
                        </v-select>
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.formPro.proveedor.$error &&
                              !$v.formPro.proveedor.required,
                          }"
                        >
                          Debe seleccionar un Proveedor
                        </div>
                      </div>
                      </div>
                      <!-- <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Sucursal</p>
                          <input
                            disabled
                            id="name"
                            v-model="$v.formPro.tienda.$model"
                            type="text"
                            class="form-control"
                            placeholder="Ingrese una Tienda"
                            :class="{
                              'is-invalid': $v.formPro.tienda.$error,
                            }"
                          />
                        </div>
                      </div> -->
                      <!-- <div class="col-sm-3">
                        <div>
                          <p class="text-muted mb-2">Fecha de Compra</p>
                          <date-picker
                            v-model.trim="$v.formPro.fecha_compra.$model"
                            :state="!$v.formPro.fecha_compra.$error"
                            :first-day-of-week="1"
                            lang="en"
                          ></date-picker>
                          <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.fecha_compra.$error &&
                                !$v.formPro.fecha_compra.required,
                            }"
                          >
                            Debe ingresar una fecha
                          </div>
                        </div>
                      </div> -->
                      <!-- <div class="col-sm-3">
                        <div>
                          <p class="text-muted mb-2">Fecha de Entrega</p>
                          <date-picker
                            v-model.trim="$v.formPro.fecha_entrega.$model"
                            :state="!$v.formPro.fecha_entrega.$error"
                            :first-day-of-week="1"
                            lang="en"
                          ></date-picker>
                          <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.fecha_entrega.$error &&
                                !$v.formPro.fecha_entrega.required,
                            }"
                          >
                            Debe ingresar una fecha
                          </div>
                        </div>
                      </div> -->
                   

                      <!-- <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">No. Factura</p>
                          <input
                            id="name"
                            v-model="$v.formPro.factura.$model"
                            type="text"
                            class="form-control"
                            placeholder="Ingrese un numero de factura"
                            :class="{
                              'is-invalid': $v.formPro.factura.$error,
                            }"
                          />
                          <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.factura.$error &&
                                !$v.formPro.factura.required,
                            }"
                          >
                            Debe ingresar un numero
                          </div>
                        </div>
                      </div> -->
                      <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Tipo de Pago</p>
                          <select
                            class="form-control"
                            v-model="formPro.metodo_pago"
                          >
                            <option value="0">Contado</option>
                            <option value="1">Crédito</option>
                          </select>
                        </div>
                      </div>
                      <!-- <div class="col-sm-3" v-if="formPro.metodo_pago == '1'">
                        <div>
                          <p class="text-muted mb-2">Fecha Limite</p>
                          <date-picker
                            v-model.trim="$v.formPro.fecha_limite.$model"
                            :state="!$v.formPro.fecha_limite.$error"
                            :first-day-of-week="1"
                            lang="en"
                          ></date-picker>
                          <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.fecha_limite.$error &&
                                !$v.formPro.fecha_limite.required,
                            }"
                          >
                            Debe ingresar una fecha
                          </div>
                        </div>
                      </div> -->
                      <div class="col-md-2">
                      <p class="text-muted">observaciones</p>
                      <textarea
                        name="textarea"
                        v-model="formPro.observaciones"
                        rows="2"
                        cols="40"
                      ></textarea>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <Loader :loading="loadingtable">
      <b-tabs
        justified
        nav-class="nav-tabs-custom"
        content-class="p-3 text-muted"
      >
      <b-tab active>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <h5><i class="bx bxs-folder-plus"></i></h5>
          </span>
          <h5>
            <span class="d-none d-sm-inline-block">
              <i class="bx bxs-folder-plus"></i>Seleccionar Producto</span
            >
          </h5>
        </template>
        <div class="row">
          <div class="col-12">
            <Loader :loading="loadingtable">
              <div class="row mt-4">
                <div class="col-sm-12 col-md-2">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Mostrar&nbsp;
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        @input="changePageSize()"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-2">
                  
                </div>
                <div class="col-sm-12 col-md-2">
                  <div
                    id="tickets-table_length"
                    class="dataTables_length text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      <b-dropdown v-if="searchType" id="ddown1" size="sm">
                        <template v-slot:button-content>
                          {{ "Buscar por: " + searchLabel.nombre }}
                          <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <b-dropdown-item
                          v-for="(search, index) in searchType"
                          :key="index"
                          @click="changeTypeSearch(search)"
                          >{{ search.nombre }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 text-md-start">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="search"
                        type="search"
                        @input="onFiltered()"
                        placeholder="Buscar..."
                        class="form-control form-control-sm"
                      ></b-form-input>
                    </label>
                  </div>
                </div>

                <div class="col-sm-12 col-md-5">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  ></div>
                </div>

                <!-- End search -->
              </div>
              <vuetable
                small
                striped
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :http-options="httpOptions"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fieldsBusqueda"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
                <div
                  slot="actions"
                  slot-scope="props"
                  v-if="verificarstock(props.rowData) != true"
                >
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Agregar"
                      variant="outline-primary"
                      @click="agregarDetalle(props.rowData)"
                      ><i class="bx bx-check"></i>
                    </b-button>
                  </b-button-group>
                </div>

                <div slot="precio_compra" slot-scope="props">
                  <h6>{{ formatQuetzales(props.rowData.precio_compra) }}</h6>
                </div>
                <!-- <div slot="codigo" slot-scope="props">
                  <h6>{{ props.rowData.Stock.codigo_stock }}</h6>
                </div> -->
              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </b-tab>
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <h5><i class="bx bxs-food-menu"></i></h5>
            </span>
            <h5>
              <span class="d-none d-sm-inline-block">
                <i class="bx bxs-food-menu"></i>Asignar detalles</span
              >
            </h5>
          </template>

          <b-table
          small
          striped
            responsive
            v-if="arrayDetalle.length > 0"
            ref="table"
            :items="arrayDetalle"
            :fields="cabezera"
          >
            <template #cell(nombre)="data">
              {{ data.item.nombre_producto }}
            </template>
            <template #cell(codigo)="data">
              {{ data.item.codigo_stock }}
            </template>
            <template #cell(precio_compra)="data">
              <masked-input
                v-model="data.item.precio_compra"
                @keyup="updateDisableDates(data)"
                :mask="mask_quetzal"
                class="form-control"
                :guide="false"
                :keep-char-positions="true"
                :show-mask="true"
                type="text"
                placeholder="Ingrese preccio"
              />
            </template>

            <template #cell(precio_venta)="data">
              <masked-input
                v-model="data.item.precio_venta"
                :mask="mask_quetzal"
                class="form-control"
                :guide="false"
                :keep-char-positions="true"
                :show-mask="true"
                type="text"
                placeholder="Ingrese preccio"
              />
            </template>
            <template #cell(subtotal)="data">
              {{ formatQuetzales(data.item.subtotal) }}
            </template>
      
            <template #cell(cantidad)="data">
              <b-form-input
                @keyup="updateDisableDates(data)"
                v-model="data.item.cantidad"
                placeholder="Cantidad"
              ></b-form-input>
            </template>
          </b-table>
          <!-- <div class="row">
            <div class="col-12">
              <div v-if="$v.arrayDetalle.$error">
                <div class="alert alert-danger">Debe ingresar detalles</div>
              </div>
            </div>
          </div> -->
        </b-tab>

        <b-tab v-if="formPro.metodo_pago == '1'">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <h5><i class="bx bxs-folder-plus"></i></h5>
            </span>
            <h5>
              <span class="d-none d-sm-inline-block">
                <i class="bx bxs-folder-plus"></i>Metodos de Compra</span
              >
            </h5>
          </template>

          <!-- Metodos de pago -->
          <b-tabs pills vertical nav-wrapper-class="w-50">
            <!-- Efectivo -->
            <b-tab :disabled="checkSelect.efectivo">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.efectivo">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Efectivo</span
                  >&nbsp;
                  <i class="fas fa-money-bill"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.efectivo"
                  @input="checkboxChange('efectivo')"
                  >&nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <b-form-group label="MONTO">
                  <masked-input
                    :disabled="!checkMoney.efectivo"
                    v-model.trim="$v.cantidad_efectivo.$model"
                    :mask="mask_quetzal"
                    :guide="false"
                    :keep-char-positions="true"
                    :show-mask="true"
                    type="text"
                    @input="sumarCantidades(1, cantidad_efectivo)"
                    placeholder="Ingresar el monto a pagar"
                    :class="{
                      'is-invalid': $v.cantidad_efectivo.$error,
                    }"
                    class="form-control"
                  />
                  <div
                    v-if="checkMoney.efectivo"
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.cantidad_efectivo.$invalid &&
                        !$v.cantidad_efectivo.$invalid.required,
                    }"
                  >
                    Debe ingresar el monto
                  </div>
                </b-form-group>
              </b-card>
            </b-tab>
            <!-- Transferencia -->
            <b-tab :disabled="checkSelect.transferencia">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.transferencia">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Transferencias</span
                  >&nbsp;
                  <i class="far fa-handshake"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.transferencia"
                  @input="checkboxChange('transferencia')"
                  >&nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <b-form-group label="NÚMERO DE TRANSACCIÓN">
                  <b-form-input
                    :disabled="!checkMoney.transferencia"
                    :class="{
                      'is-invalid':
                        $v.transferencia.transaccion_transferencia.$error,
                    }"
                    v-model.trim="
                      $v.transferencia.transaccion_transferencia.$model
                    "
                    placeholder="Ingresar en número de transacción"
                    @input="
                      sumarCantidades(
                        2,
                        transferencia.transaccion_transferencia
                      )
                    "
                  >
                  </b-form-input>
                  <div
                    v-if="checkMoney.transferencia"
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.transferencia.transaccion_transferencia.$invalid &&
                        !$v.transferencia.transaccion_transferencia.$invalid
                          .required,
                    }"
                  >
                    Debe ingresar el número de transacción
                  </div>
                </b-form-group>
                <br />
                <b-form-group label="MONTO">
                  <masked-input
                    :disabled="!checkMoney.transferencia"
                    v-model.trim="
                      $v.transferencia.cantidad_transferencia.$model
                    "
                    :mask="mask_quetzal"
                    :guide="false"
                    :keep-char-positions="true"
                    :show-mask="true"
                    type="text"
                    @input="
                      sumarCantidades(1, transferencia.cantidad_transferencia)
                    "
                    placeholder="Ingresar el monto a pagar"
                    :class="{
                      'is-invalid':
                        $v.transferencia.cantidad_transferencia.$error,
                    }"
                    class="form-control"
                  />
                  <div
                    v-if="checkMoney.transferencia"
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.transferencia.cantidad_transferencia.$invalid &&
                        !$v.transferencia.cantidad_transferencia.$invalid
                          .required,
                    }"
                  >
                    Debe ingresar el monto
                  </div>
                </b-form-group>
              </b-card>
            </b-tab>
            <!-- Cheque -->
            <b-tab :disabled="checkSelect.cheque">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.cheque">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Cheques</span
                  >&nbsp;
                  <i class="far fa-credit-card"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.cheque"
                  @input="checkboxChange('cheque')"
                  >&nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <b-form-group label="NÚMERO DE CHEQUE">
                  <b-form-input
                    :disabled="!checkMoney.cheque"
                    v-model.trim="$v.cheque.transaccion_cheque.$model"
                    placeholder="Ingresar en número de transacción"
                    @input="sumarCantidades(2, cheque.transaccion_cheque)"
                    :class="{
                      'is-invalid': $v.cheque.transaccion_cheque.$error,
                    }"
                  >
                  </b-form-input>
                  <div
                    v-if="checkMoney.cheque"
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.cheque.transaccion_cheque.$invalid &&
                        !$v.cheque.transaccion_cheque.$invalid.required,
                    }"
                  >
                    Debe ingresar el número de transacción
                  </div>
                </b-form-group>
                <br />
                <b-form-group label="MONTO">
                  <masked-input
                    :disabled="!checkMoney.cheque"
                    v-model.trim="$v.cheque.cantidad_cheque.$model"
                    :mask="mask_quetzal"
                    :guide="false"
                    :keep-char-positions="true"
                    :show-mask="true"
                    type="text"
                    @input="sumarCantidades(1, cheque.cantidad_cheque)"
                    placeholder="Ingresar el monto a pagar"
                    :class="{
                      'is-invalid': $v.cheque.cantidad_cheque.$error,
                    }"
                    class="form-control"
                  />
                  <div
                    v-if="checkMoney.cheque"
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.cheque.cantidad_cheque.$invalid &&
                        !$v.cheque.cantidad_cheque.$invalid.required,
                    }"
                  >
                    Debe ingresar el monto
                  </div>
                </b-form-group>
              </b-card>
            </b-tab>
          </b-tabs>
          <br />
          <div class="row">
            <div class="col">
              <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                <h2 class="mt-0 mb-4 text-white">
                  <i class="bx bx-list-check me-3"></i> Total a pagar
                </h2>
                <h3 class="mt-0 mb-4 text-white" align="center">
                  {{ money(formPro.total) }}
                </h3>
              </b-card>
            </div>
            <div class="col">
              <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                <h2 class="mt-0 mb-4 text-white">
                  <i class="bx bx-detail me-3"></i> Cantidad pagando
                </h2>
                <h3 class="mt-0 mb-4 text-white" align="center">
                  {{
                    money(montoFinal.cantidad >= 0 ? montoFinal.cantidad : 0.0)
                  }}
                </h3>
              </b-card>
            </div>
          </div>
        </b-tab>
      </b-tabs>

      <div class="col-sm-12 pt-3">
        <div class="row">
          <div class="col">
            <router-link
              class="d-grid gap-2"
              :to="{
                name: 'compras',
              }"
            >
              <b-button
                block
                size="lg"
                variant="outline-primary"
                type="button"
                class="btn btn-rounded mb-2 me-2"
              >
                <i class="bx bx-arrow-back"></i>&nbsp;&nbsp;<b>REGRESAR</b>
              </b-button>
            </router-link>
          </div>
          <div class="col d-grid gap-2">
            <b-button
              block
              size="lg"
              variant="outline-success"
              class="btn btn-rounded mb-2 me-2"
              @click="validaciones('save')"
            >
              {{ tomandototal() }}
              <i class="mdi mdi-truck-fast me-1"></i>
              &nbsp;&nbsp;<b>GUARDAR</b>
            </b-button>
          </div>
        </div>
      </div>
    </Loader>
    <!-- end row -->
  </Layout>
</template>
